export default __webpack_public_path__ + "static/media/WildPlains.8cdb9877.jpg";